import {
  locationTypeDisplayName,
  selectAllLocationTypes,
  useGetLocationTypesOnMount,
} from '@user/store/locationTypes'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { SelectItem } from '../typings'

export function useLocationTypes() {
  const status = useGetLocationTypesOnMount()

  const loading = status === 'pending'

  const locationTypes = useSelector(selectAllLocationTypes)

  const formattedLocationTypes = useMemo<SelectItem[]>(
    () =>
      locationTypes.map((l) => ({
        label: locationTypeDisplayName(l),
        value: l.id,
      })),
    [locationTypes],
  )

  return [loading, formattedLocationTypes] as const
}
